import { ChartsTooltipProps } from '@mui/x-charts/ChartsTooltip';
import React from 'react';

import ChartTooltip, { ChartTooltipFooter } from 'components/charts/chart-tooltip';
import { useMetricFormatters } from 'views/playground/features/data-lab/hooks/use-metric-formatters';

// Forward slot props so each chart keeps its native trigger; Pie and Scatter pass `trigger="item"`.
const DataLabChartTooltip = (props: ChartsTooltipProps) => {
  const { formatCount } = useMetricFormatters();

  const totalFooter: ChartTooltipFooter = (_dataIndex, values) =>
    values.length > 1 ? { label: 'Total', value: formatCount(values.reduce((total, value) => total + value, 0)) } : null;

  return <ChartTooltip {...props} footer={totalFooter} />;
};

export default DataLabChartTooltip;
